"use client";

import type { OmniboxDemo } from "@mw/shared/payload-types";

import { useTranslations } from "next-intl";
import { usePostHog } from "posthog-js/react";

import { Button } from "./Button";

export interface SampleEventDetail {
  sampleType: OmniboxDemo["component"];
}

export default function SampleButton({
  className,
  style,
  sampleType,
}: {
  children?: React.ReactNode;
  className?: string;
  sampleType: OmniboxDemo["component"];
  style?: React.CSSProperties;
}) {
  const posthog = usePostHog();
  const t = useTranslations("ClientKeys.Globals");
  const buttonText = t("sample_button.text");

  function captureEvent() {
    posthog.capture("website_clicked_herobutton", {
      textContent: buttonText,
    });
  }

  function handleClick() {
    const event = new CustomEvent<SampleEventDetail>("sample", { detail: { sampleType } });
    document.dispatchEvent(event);
    captureEvent();
  }

  return (
    <Button className={className} onClick={handleClick} style={style} variant='secondary'>
      {buttonText}
    </Button>
  );
}
